import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 18,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M.35 6.7l1.42 1.42L6 3.9v13.46h2V3.77l4.35 4.35 1.42-1.41L7.07 0 .34 6.7z",
		fill: "#9EA3AD"
	})
});
export default SvgArrowUp;
